import { Splide } from "@splidejs/splide";
import { clientsLogoSlider } from "./sliders";

export default class ClientsLogo {
    private section: HTMLElement;
    private clientsLogoWrapper: HTMLElement | null;
    private slider: Splide | null = null;
    private breakpoint: string;

    constructor(section: HTMLElement) {
        this.section = section;
        this.clientsLogoWrapper = this.section.querySelector("#clients-logo");
        this.breakpoint = "(max-width: 1280px)";

        this.init();
    }

    public init = async (): Promise<void> => {
        if (!this.clientsLogoWrapper) return;

        this.slider = clientsLogoSlider(this.clientsLogoWrapper);

        if (!window.matchMedia(this.breakpoint).matches) this.slider.destroy();

        window.matchMedia(this.breakpoint).addEventListener("change", this.changeSliderState);
    };

    private changeSliderState = ({ matches }: MediaQueryListEvent) => {
        if (!this.clientsLogoWrapper) return;

        matches ? this.slider?.mount() : this.slider?.destroy();
    };
}
